import { Seo } from "@/components/Seo";
import { ContactSection } from "@/components/ContactSection";

export default function Contact() {
  return (
    <>
      <Seo path="/contact" />
      <ContactSection headingLevel="h1" />
    </>
  );
}
